"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./DataList.css");
var Row_1 = __importDefault(require("./Row"));
var Cell_1 = __importDefault(require("./Cell"));
var HeaderBulkAction_1 = __importDefault(require("./HeaderBulkAction"));
var DataContext_1 = require("../DataContext");
function DataList(_a) {
    var children = _a.children, _b = _a.ruled, ruled = _b === void 0 ? true : _b, editMode = _a.editMode, _c = _a.spacing, spacing = _c === void 0 ? "base" : _c, _d = _a.skeleton, skeleton = _d === void 0 ? false : _d, _e = _a.background, background = _e === void 0 ? "none" : _e, bulkAction = _a.bulkAction, selectedRowsId = _a.selectedRowsId, onEditMode = _a.onEditMode, onSelectRow = _a.onSelectRow;
    var className = (0, classnames_1.default)("nimbus--data-list-wrapper", { "nimbus--data-list-wrapper--ruled": ruled }, { "nimbus--data-list-wrapper--actions": bulkAction && editMode }, { "nimbus--data-list-wrapper--edit-mode": editMode }, "nimbus--data-list-wrapper--background-".concat(background), "nimbus--data-list-wrapper--spacing-".concat(spacing));
    return (React.createElement(DataContext_1.DataContextProvider, { bulkAction: bulkAction, editMode: editMode, skeleton: skeleton, onEditMode: onEditMode, selectedRowsId: selectedRowsId, onSelectRow: onSelectRow },
        React.createElement("div", { className: className },
            bulkAction && React.createElement(HeaderBulkAction_1.default, { bulkAction: bulkAction }),
            React.createElement("div", { className: "nimbus--data-list" },
                React.createElement("div", { className: "nimbus--data-list__body" }, children)))));
}
DataList.Row = Row_1.default;
DataList.Cell = Cell_1.default;
exports.default = DataList;
//# sourceMappingURL=DataList.js.map